var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chatList.length == 0)?_c('van-empty',{attrs:{"description":"发挥您的创意,让AI帮您生成精美的图片吧~"}}):_c('div',{staticStyle:{"padding-top":"5%"}},[_c('ChatView',{ref:"chat_view_message",attrs:{"isSet":true,"chatList":_vm.chatList},on:{"insertMethod":_vm.insertMethod}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }